type DashboardLoadingProps = {
	message?: string;
};

const DashboardLoading = ({ message }: DashboardLoadingProps) => {
	return (
		<div className="rounded-lg border border-white/10 bg-white/[0.03] p-6 text-slate-300">
			<div className="mb-3 h-2 w-24 rounded-full bg-accent-color-2/40" />
			<h1 className="m-0 text-2xl text-white">Loading your dashboard...</h1>
			<p className="m-0 mt-2 text-sm text-slate-400">
				{message ??
					"Checking your account, athletes, registrations, and available events."}
			</p>
		</div>
	);
};

export default DashboardLoading;
